module.exports = __webpack_public_path__ + "img/Logo_BizscreenFinal_Blanc.61623936.svg";